var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.gameData)?_c('base-level',{ref:"base",attrs:{"level_id":_vm.gameData.level_id,"level_name":_vm.gameData.level_name,"level_data":_vm.gameData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }